// src/features/dashboard/mocks/appList.mock.ts

import type {
  AppListApiResponse,
  AppListItem,
} from '../types/appList.types';

/**
 * =========================================
 * MOCK PRODUCTIVE APPS
 * =========================================
 */
export const productiveAppsMockData: AppListApiResponse[] = [
  {
    applicationName: 'Microsoft Teams',
    applicationTypeLabel: 'Productive',
    avgHoursPerDay: 3.5,
    percentage: 35,
    colorHex: '#22C55E',
  },
  {
    applicationName: 'Outlook',
    applicationTypeLabel: 'Productive',
    avgHoursPerDay: 2.8,
    percentage: 28,
    colorHex: '#3B82F6',
  },
  {
    applicationName: 'Excel',
    applicationTypeLabel: 'Productive',
    avgHoursPerDay: 1.9,
    percentage: 19,
    colorHex: '#10B981',
  },
];

/**
 * =========================================
 * MOCK NON PRODUCTIVE APPS
 * =========================================
 */
export const nonProductiveAppsMockData: AppListApiResponse[] = [
  {
    applicationName: 'YouTube',
    applicationTypeLabel: 'NonProductive',
    avgHoursPerDay: 1.2,
    percentage: 45,
    colorHex: '#EF4444',
  },
  {
    applicationName: 'Instagram',
    applicationTypeLabel: 'NonProductive',
    avgHoursPerDay: 0.8,
    percentage: 30,
    colorHex: '#F97316',
  },
  {
    applicationName: 'Facebook',
    applicationTypeLabel: 'NonProductive',
    avgHoursPerDay: 0.6,
    percentage: 25,
    colorHex: '#F59E0B',
  },
];

/**
 * =========================================
 * MAP API RESPONSE
 * =========================================
 */
export const mapAppListData = (
  response: AppListApiResponse[],
): AppListItem[] => {

  return response.map((item) => ({

    name:
      item.applicationName,

    subtitle:
      `${item.applicationTypeLabel} · ${item.avgHoursPerDay} hr/day`,

    percentage:
      Number(
        item.percentage.toFixed(0),
      ),

    color:
      item.colorHex,

    avgHours:
      item.avgHoursPerDay,
  }));
};